import React, { Fragment } from 'react'
import { Field } from 'redux-form'

import { translate, utils } from 'parking-react-common'

import { forms, ui } from '../redux'

import Panel from '../components/Panel'
import Button from '../components/Button'
import Input from '../components/Input'
import PhoneNumberInput from '../components/PhoneNumberInput'
import { Column, Row } from '../components/Grid'
import form from '../components/Form'

const InvitationForm = ({ t }) => (
    <Panel title={ t('Invite user to join {{project}}', { project: utils.featureFlag('projectNameShort') }) }>
        <Column span={ 8 }>
            { utils.featureFlag('authMethod') === 'sms' && (
                <Fragment>
                    <Field
                        name="phone"
                        component={ PhoneNumberInput }
                        placeholder={ t('Phone Number') }
                    />
                    <Field
                        name="email"
                        component={ Input }
                        placeholder={ t('Email Address') }
                        description={ t('Optional. Fill in if you want to also want to send the invite via e-mail') }
                    />
                </Fragment>
            ) }
            { utils.featureFlag('authMethod') === 'email' && (
                <Fragment>
                    <Field
                        name="email"
                        component={ Input }
                        placeholder={ t('Email Address') }
                    />
                    <Field
                        name="phone"
                        component={ PhoneNumberInput }
                        placeholder={ t('Phone Number') }
                        description={ t('Optional. Fill in if you want to also want to send the invite via SMS') }
                    />
                </Fragment>
            ) }
            <br />
            <br />
            <Row>
                <Column span={ 6 }>
                    <Button
                        type="submit"
                        label={ t('Send Invitation') }
                        size={ ui.SIZE.large }
                        intent={ ui.INTENT.primary }
                        isBlock
                    />
                </Column>
            </Row>
        </Column>
    </Panel>
)

InvitationForm.propTypes = forms.propTypes

export default translate()(form({ id: forms.invitation.id })(InvitationForm))
